import BillingEmptyState from 'billing/components/BillingEmptyState'
import { Task } from 'mobx-task'
import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'

interface PayoutMethodsEmptyState {
  canAddPayoutMethod: boolean
  onNewPayoutMethod: Task<unknown[], unknown>
}

export default observer(function PayoutMethodsEmptyState({
  canAddPayoutMethod,
  onNewPayoutMethod,
}: PayoutMethodsEmptyState) {
  return (
    <BillingEmptyState
      title="There are no Payout Methods"
      subtitle="No payout methods have been set up."
    >
      {canAddPayoutMethod && (
        <Button
          disabled={onNewPayoutMethod.pending}
          loading={onNewPayoutMethod.pending}
          type="primary"
          onClick={() => onNewPayoutMethod()}
        >
          Add New Payout Method
        </Button>
      )}
    </BillingEmptyState>
  )
})
